export enum Messages {
  getInformation = 'C kit-global.agency хотят получить больше информации о возможностях сотрудничества.',
  toOrderDev = 'C kit-global.agency хотят заказать разработку.',
  requestCall = 'C kit-global.agency хотят заказать звонок'
}